// skipcq: JS-W1028
import React from 'react';
// skipcq: JS-0257
import PropTypes from 'prop-types';
// mui
import Grid from '@mui/material/Grid';
// components
import Amenities from '../../components/amenities/Amenities';

function BreweryAmenities({ amenities }) {
  return (
    <Grid container spacing={2} sx={{
      padding: 2
    }}>
      <Grid item xs={12} md={6}>
        <Amenities
          amenities={amenities}
          settings={{ showLabels: true, vertical: true }}
        />
      </Grid>
    </Grid>
  );
}

BreweryAmenities.propTypes = {
  amenities: PropTypes.array.isRequired,
};

export default BreweryAmenities;
